import billingService from '@/app-domains/user/billing/billing.service'
import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import React, { useEffect } from 'react'
// eslint-disable-next-line
import store from '@/core/store'
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'

import './CancelTrialModal.scoped.sass'
import AuthService from '@/app-domains/user/auth/Auth.service'

export function CancelTrialModal () {
  useEffect(async () => {
    // Call here API for getting cancelling subscription data
  }, [])

  async function cancelSubscriptionWithType (type) {
    await billingService.cancelTrialSubscription(type)
    modalService.close()
    AuthService.signOut()
    // store.commit('SUBSCRIPTION:CHANGED')
  }
  
  return (<div className='cancel-subscription-modal'>
    <div className='cancel-subscription-header'>
      <div>
        <p className='main-phrase'>We are sad to see you go!</p>
        <p className='main-subphrase'>( But we will try to make it as simple as possible )</p>
      </div>
      <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
    </div>
    <div className='cancel-subscription-content'>
      <p>
        <SimpleBanner type='warning'>
          <span className='font-medium'>REMEMBER:</span><br/>
          Boxes is a one-of-a-kind service, so once canceled all the different emails addresses (Boxes) you have set up will no longer function.
          {/* <br/><br/> */}
          {/* You own your data and after you cancel we will send you a message with a link where you can download your data and attachments to your computer. */}
        </SimpleBanner>
      </p>
      <p>
        If you are absolutely sure you want to cancel, click the link below and we will begin the process for you.
      </p>
      <div className='cancel-options'>
        <a className='cancel-option' onClick={() => cancelSubscriptionWithType('plain-cancel')}>Cancel my Boxes service</a>
      </div>
    </div>
    <div className='cancel-actions'>
      <div className='close-cancel'>
        <Button content="Nevermind, I don't want to cancel" type='primary' click={() => modalService.close()}/>
      </div>
    </div>
    
  </div>)
}
